<template>
  <div id="coupon-carousel">
    <div class="coupon-carousel-inner" v-if="coupons.length > 0">
      <swiper
          :options="swiperOptions"
          navigation="true"
          :modules="modules"
          ref="couponCarousel"
          :autoplay="modules[1]"
          @click="testEmit"
          @touchend="triggerModal"

      ><!--   @click="selectCoupon(this)"-->
        <swiper-slide v-for="(coupon,index) in coupons" :read-index="index" :key="index" >
          <img :src="coupon.cdn_url" class="img-fluid" :read-index="index"   />
        </swiper-slide>
        <template v-slot:button-prev>
          <div class="swiper-button-prev" @click="$refs.couponCarousel.swiperInstance.slidePrev()"></div>
        </template>
        <template v-slot:button-next>
          <div class="swiper-button-next" @click="$refs.couponCarousel.swiperInstance.slideNext()"></div>
        </template>
      </swiper>
    </div>
  </div>
</template>
<!-- @TODO - May need to split functionality here as PPC doesn't technically support Vue Bootstrap -->
<script>
//@TODO - Below functionally brings in working modules (and likely fixes our issues in other areas utilizing Swiper JS
import {Swiper as SwiperClass, Navigation, Autoplay} from 'swiper/swiper.esm'
SwiperClass.use([Navigation,Autoplay]);
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
const {Swiper,SwiperSlide} = getAwesomeSwiper(SwiperClass);
//import { Navigation, Autoplay } from 'swiper';
//import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data: () => {
    return {
      currentSlide: 0,
      modules: [Navigation, Autoplay],
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: {
         delay: 3000,
         disableOnInteraction: false
        },
        spaceBetween: 15,
        loop: true,
        slidesPerView: 1,
        edgeSwipeDetection: true,
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          565: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1200: {
            slidesPerView: 4
          },
        }
      }
    }
  },
  props: {
    coupons: Array
  },
  created(){

  },
  mounted: function () {
    this.$nextTick(() => {
      console.log(this.swiper);

      //this.$refs.couponCarousel.swiperInstance.autoplay.run();
    });
    //this.$refs.couponCarousel.swiperInstance.autoplay.start();
  },
  computed: {
    promotion(){
      return this.$store.state.promotion;
    },
    swiper(){
      return this.$refs.couponCarousel.$swiper;
    }
  },
  methods: {
    selectCoupon(index){
      this.$emit('couponClicked',index);
    },
    slideClick(val){
      console.log(val);
      console.log('slide click works');
    },
    triggerModal(){
      this.$emit('triggerModal');
    },
    testEmit(e){
      console.log(e);
      if(e.clickedSlide !== undefined){
       if(e.clickedSlide.dataset.swiperSlideIndex !== undefined){
         this.$emit('couponClicked',e.clickedSlide.dataset.swiperSlideIndex);
       } else {
         this.$emit('couponClicked',0);
       }
      }
    }
  },
}
</script>

<style scoped>
.coupon-image:hover {
  cursor: pointer;
}
.swiper-slide {
  text-align:center;
}
.swiper-container {
  width: 100%;
}
.swiper-button-prev:after, .swiper-button-next:after {
  font-size:25px;
}
.swiper-button-prev, .swiper-button-next {
  background: black;
  border-radius: 200%;
  width: 50px;
  height: 50px;
  color: white;
}
.swiper-button-prev.disabled {
  background: #f3f3f3;
}
.swiper-button-prev {
  left:0px;
}
.swiper-button-next {
  right:0px;
}
.swiper-button-next.ajax-spinner {
  visibility: hidden !important;
}
.ajax-spinner {
  position: absolute;
  right: 0;
  margin-right: 15px;
  z-index: 999;
  width: 50px;
  height: 50px;
  margin-top: 4px;
}
@media(max-width:410px){
  .swiper-slide-active, .swiper-slide-next {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.appt-date .error-message {
  color:red;
}
</style>
